export default function translate(i18n, propriete) {
  if (propriete.indexOf('prestation') !== -1) {
    const prefixI18n = 'catalogue.validation.prestation.';
    if (propriete.endsWith('tauxTva')) return i18n.t(`${prefixI18n}tauxTva`);
  }
  return propriete;
}
